import { Link01Icon } from '@/components/icons/Link01Icon';
import { DeliverableCard } from '@/components/layout/DeliverableCard/DeliverableCard';
import { useNavigateToRoute } from '@/components/navigation/useNavigateToRoute';
import { useHouseholdDetailsContext } from '@/modules/household/contexts/householdDetails.context';
import { ManageIntegrationDataPane } from '@/modules/household/ManageIntegrationDataModal/ManageIntegrationDataModal.types';
import {
  TROWSER_PARAM,
  TROWSER_SECTION_PARAM,
  TrowserKey,
} from '@/modules/navigation/trowsers/trowser.types';
import { ROUTE_KEYS } from '@/navigation/constants';

import { useHouseholdConnectionDetails } from './useHouseholdConnectionDetails';

export function AssetIntegrationPromptCard() {
  const { navigate } = useNavigateToRoute();
  const { householdId } = useHouseholdDetailsContext();
  const { integrationDisplayName, integrationConnected } =
    useHouseholdConnectionDetails();

  const handleIntegrationClick = () => {
    // ts check
    if (!householdId) return;

    // A linked household does not need to select integration clients again.
    const initialPane = integrationConnected
      ? ManageIntegrationDataPane.LinkTrusts
      : ManageIntegrationDataPane.SelectClients;

    return navigate(
      ROUTE_KEYS.HOUSEHOLD_ESTATE_BALANCE_SHEET,
      {
        householdId,
      },
      {
        [TROWSER_PARAM]: TrowserKey.LinkHouseholdData,
        [TROWSER_SECTION_PARAM]: initialPane,
      }
    );
  };

  return (
    <DeliverableCard
      icon={Link01Icon}
      title={`Import from ${integrationDisplayName}`}
      description={`Recommended if ${integrationDisplayName} serves as the source of truth for trusts and businesses`}
      sizeVariant="large"
      onClick={handleIntegrationClick}
      hideBadge
    />
  );
}
